import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const Header: FC = () => {
    const { t } = useTranslation()

    return (
        <View style={styles.header}>
            <Typography.Heading variant="h3">
                {t('settings.printers.addPrinterModal.heading')}
            </Typography.Heading>
            <Typography.Description style={styles.description}>
                {t('settings.printers.addPrinterModal.description')}
            </Typography.Description>
        </View>
    )
}

const styles = StyleSheet.create({
    header: {
        alignItems: 'center',
        gap: 8,
    },
    description: {
        color: ColorEnum.JET_500,
    },
})

export default Header
